module.exports = __webpack_public_path__ + "img/cj02.1331605a.jpg";